<div class="premium-dialog-ui">
    <div class="form-row align-item-center">
        <div class="col-auto">
            <img src="/assets/images/premium-invites.svg" class="premium-icon" alt="Premium invite">
        </div>
        <div class="col-10 m-title col-md">
            Craft Invitation with personalized envelope
        </div>
        <div class="close-button" (click)="close()">
            <span class="material-icons">
                close
            </span>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col-md-6">
            <div class="mx-auto" style="width: fit-content;">
                <div class="mobile_header ng-tns-c3588437439-0"></div>
                <div class="mobile_body">
                    <iframe src="https://rsvp.247invites.com/wedding-invitation/envelope/eyJ2aWRlb0lkIjoiNzMifQ%3D%3D" frameborder="0"></iframe>
                </div>
                <div class="mobile_footer ng-tns-c3588437439-0"></div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="premium-preview-modal__details premium">
                <div class="premium-preview-modal__detail-section">
                    <p class="font-weight-bold">
                        Explore our exceptional feature: RSVP directly on the
                        payment page. Simply copy the link from
                        our download page post-payment and effortlessly share it
                        via WhatsApp.
                    </p>
                    <div class="premium-preview-modal__detail-item
                        p-model-content mt-4">
                        <div class="form-row align-item-center">
                            <div class="col-auto">
                                <img src="/assets/images/premium-invites.svg" class="premium-icon-small"
                                    alt="Premium invite">
                            </div>
                            <div class="col">
                                <p class="pera">Elevate your invitation with a
                                    captivating envelope animation in your
                                    video, offering your guests a premium
                                    experience.</p>
                            </div>
                        </div>
                        <div class="form-row align-item-center">
                            <div class="col-auto">
                                <img src="/assets/images/premium-invites.svg" class="premium-icon-small"
                                    alt="Premium invite">
                            </div>
                            <div class="col">
                                <p class="pera">Receive a shareable invitation
                                    link directly from our download page.</p>
                            </div>
                        </div>
                        <div class="form-row align-item-center">
                            <div class="col-auto">
                                <img src="/assets/images/premium-invites.svg" class="premium-icon-small"
                                    alt="Premium invite">
                            </div>
                            <div class="col">
                                <p class="pera">Share the link effortlessly
                                    across WhatsApp, email, and various social
                                    media platforms.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>